import { FC, ReactElement, useContext } from 'react';
import styles from '../index.module.scss';
import userCenter from '@/constants/userCenter';
import { namespace, StoreContext } from '@/context';

/** 登录提示卡片内容列表 */
export interface LoginTipOption {
  key: string,
  label: string,
  icon: ReactElement,
}
/** 登录提示卡片组件props */
interface LoginTipsProps {
  title: string;
  options: LoginTipOption[];
}
// 登录提示卡片
const LoginTips: FC<LoginTipsProps> = ({
  title,
  options
}) => {
  const { state } = useContext(StoreContext);
  const { track, TRACK_EVENTS } = state[namespace.app].sensors || {};
  return (
    <div
      className={styles.loginTipsCard}
      onClick={() => {
        track?.(TRACK_EVENTS?.[namespace.home].loginButtonClick.name, {
          position: 'BottomCard'
        }, namespace.home);
        window.open(userCenter().login, 'blank');
      }}
    >
      <div className={styles.loginTipsTitle}>{title}</div>
      <ul className={styles.tipList}>
        {
          options.map(({ key, icon, label }) => (
            <li className={styles.tipItem} key={key}>
              <div className={styles.tipIcon}>{icon}</div>
              <span>{label}</span>
            </li>
          ))
        }
      </ul>
    </div>
  )
}

export default LoginTips;